import { useEffect, useState } from "react";
import {
    Typography,
    FormControlLabel,
    Box
} from "@mui/material";
import Select from "react-select";
import DoneIcon from "@mui/icons-material/Done";

import { axiosInstance } from "../../utility/apiInstance";
import { Milestone, MilestoneGroup } from "./groupingType";
import { Card, CardContent } from "@mui/material";

const AddMilestoneGroupingForm = ({
    setmodalPopup,
    subscriptionFormData,
    setSubscriptionFormData,
    type
}: any) => {

    const [milestone, setMilestone] = useState("first");
    const getallGroupingMilestone = async () => {
        try {
            const { data } = await axiosInstance.get(`/api/v1/groupingMileStone?type=${type}`);
            setSubscriptionFormData((prev: any) => {
                return {
                    ...prev,
                    groupingmilestonesList: data?.data,
                };
            });

        } catch (error) {
            setSubscriptionFormData((prev: any) => {
                return {
                    ...prev,
                    groupingmilestonesList: [],
                };
            });
        }
    }

    useEffect(() => {
        getallGroupingMilestone();
    }, [])

    

    return (
        <Box className="modalTracking modalGrouping" sx={{ width: "100%", maxWidth: "100%", margin: "auto", padding: 4 ,minHeight:"400px"}}>
            <>
                <div className="mb-3">
                    <FormControlLabel
                        className="labelTracking"
                        control={<DoneIcon />}
                        label={<Typography variant="h6">Grouping milestone</Typography>}
                    />
                    <Select
                        isClearable
                        name="groupMilestone"
                        options={subscriptionFormData?.groupingmilestonesList?.map((item: any) => ({
                            label: item?.groupName,
                            value: item?._id,
                            item: item,
                        }))}
                        placeholder="Grouping milestone"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={subscriptionFormData?.groupMilestone || null}
                        onChange={(option: any) => {
                        
                            setSubscriptionFormData((prev: any) => {
                                return {
                                    ...prev,
                                    groupMilestone: option,
                                };
                            });

                        }}
                        styles={{
                            control: (base) => ({
                                ...base,
                                backgroundColor: "#f0f0f0",
                                border: "none",
                                boxShadow: "none",
                                "&:hover": {
                                    border: "none",
                                },
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: "#999",
                            }),
                        }}
                    />
                </div>

                {subscriptionFormData?.groupMilestone?.item && (<div className="boxTab">
                    <div className="milestonetabss">
                        {/* Tabs header */}
                        <div
                            style={{
                                display: "flex",
                                gap: "2px",
                                borderBottom: "1px solid #eee",
                            }}
                        >
                            <button
                                onClick={() => setMilestone("first")}
                                className={`milestone-btn ${milestone === "first" ? "activee" : ""
                                    }`}
                            >
                                First Mile
                            </button>

                            <button
                                onClick={() => setMilestone("last")}
                                className={`milestone-btn ${milestone === "last" ? "activee" : ""
                                    }`}
                            >
                                Last Mile
                            </button>
                        </div>

                        {/* Tab content */}
                        <div style={{ marginTop: "16px" }}>
                            {milestone === "first" && (
                                subscriptionFormData?.groupMilestone?.item.firstmilestones.map((element: Milestone) => <Card
                                    key={element._id}
                                    variant="outlined"
                                    sx={{ borderRadius: 2, marginBottom: "10px" }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#f7f7f7",
                                            padding: "12px",
                                        }}
                                    >
                                        {/* Center: label */}
                                        <Typography>{element?.name}</Typography>


                                    </CardContent>
                                </Card>
                                )
                            )}
                            {milestone === "last" && (
                                subscriptionFormData?.groupMilestone?.item.lastmilestones.map((element: Milestone) => <Card
                                    key={element._id}
                                    variant="outlined"
                                    sx={{ borderRadius: 2, marginBottom: "10px" }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#f7f7f7",
                                            padding: "12px",
                                        }}
                                    >
                                        {/* Center: label */}
                                        <Typography>{element?.name}</Typography>


                                    </CardContent>
                                </Card>

                                )
                            )}
                        </div>
                    </div>
                </div>)}
            </>


        </Box >
    );
};

export default AddMilestoneGroupingForm;
